export type PopulatedCategory = { name: string; count: number };

/**
 * Returns only filters that can produce results. Categories with the largest
 * community representation lead, with an alphabetical tie-break for stability.
 */
export function rankPopulatedCategories(categoryNames: readonly string[]): PopulatedCategory[] {
  const counts = new Map<string, number>();
  for (const categoryName of categoryNames) {
    counts.set(categoryName, (counts.get(categoryName) ?? 0) + 1);
  }
  return Array.from(counts, ([name, count]) => ({ name, count }))
    .filter(({ count }) => count > 0)
    .sort((left, right) => right.count - left.count || left.name.localeCompare(right.name));
}

export function visibleCategoryFilters(categories: readonly PopulatedCategory[], expanded: boolean, limit = 5) {
  return expanded ? [...categories] : categories.slice(0, limit);
}
